/*
 *
 * TimeSpanPlannerPage actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_AVAILABILITY_SCANNERS,
  GET_RESULT,
  GET_RESULT_FAILED,
  GET_RESULT_SUCCESS,
  GET_TIMESLOT_DRIVERS,
  GET_TIMESLOTS,
  GET_TIMESLOTS_FAILED,
  GET_TIMESLOTS_SUCCESS,
  REMOVE_ACTIVITY,
  RESET,
  SAVE_ACTIVITY,
} from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getTimeSlotsAction() {
  return {
    type: GET_TIMESLOTS,
  };
}

export function getTimeSlotsSuccessAction(timeWindows) {
  return {
    type: GET_TIMESLOTS_SUCCESS,
    timeWindows,
  };
}
export function getTimeSlotsFailedAction(reason) {
  return {
    type: GET_TIMESLOTS_FAILED,
    reason,
  };
}

export function saveActivityAction(activity) {
  return {
    type: SAVE_ACTIVITY,
    activity,
  };
}

export function removeActivityAction() {
  return {
    type: REMOVE_ACTIVITY,
  };
}

export function getResultAction() {
  return {
    type: GET_RESULT,
  };
}

export function getResultSuccessAction(result) {
  return {
    type: GET_RESULT_SUCCESS,
    result,
  };
}

export function getResultFailedAction(reason) {
  return {
    type: GET_RESULT_FAILED,
    reason,
  };
}

export function resetAction() {
  return {
    type: RESET,
  };
}

export function checkAvailability(date, duration, kptOverride, withScanner, callback) {
  return {
    type: GET_TIMESLOTS,
    date,
    duration,
    kptOverride,
    withScanner,
    callback,
  };
}
export function planAvailability(planning, timeSlotId) {
  return {
    type: GET_RESULT,
    planning,
    timeSlotId,
  };
}

export function getTimeslotDrivers() {
  return {
    type: GET_TIMESLOT_DRIVERS,
  };
}

export function getScannerAvailability(date) {
  return {
    type: GET_AVAILABILITY_SCANNERS,
    date
  };
}
